import React, {Component} from 'react';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

// import banner from "assets/img/green-hacker.jpg";
import banner from "assets/img/matrix-circle-1920.jpg";

import * as text from './pp_text';
import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

class PpPage extends Component {

  renderDisclosureOfInfo() {
    return (
      <div>
        <h3>Disclosure of Information to Others</h3>
        <p>{text.DISCLOSURE1}</p>
        <ol>{text.DISC_LIST.map((disc_li, i) =>
          <li key={i} style={{fontSize: 14}}>{disc_li}</li>
        )}</ol>
        <p>{text.DISCLOSURE2}</p>
        <p>{text.DISCLOSURE3}</p>
        <p>{text.DISCLOSURE4}</p>
      </div>
    );
  }

  render() {
    const {classes, history, auth, ...rest} = this.props;
    const B = (props) => <p style={{fontWeight:'bold'}}>{props.children}</p>;

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={banner}>
          <div className={classes.titleContainer}>
            <h1 className={classes.tcppTitle}>Privacy Policy</h1>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.termsContainer}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.profile}>
                    <div className={classes.name} style={{marginTop: 75}}>
                      <div style={{textAlign: 'left'}}>
                        <h2 style={{paddingTop: 15}}>PollPals Privacy Policy</h2>
                        <h3>Overview</h3>
                        <p>{text.OVERVIEW1}</p>
                        <B>{text.OVERVIEW2}</B>
                        <p>{text.OVERVIEW3}</p>
                        <p>{text.OVERVIEW4}</p>
                        <h3>Collection and Retention of Information</h3>
                        <p>{text.COLLECTION1}</p>
                        <p>{text.COLLECTION2}</p>
                        <p>{text.COLLECTION3}</p>
                        <p>{text.COLLECTION4}</p>
                        <h3>Use of Information by Pollpals</h3>
                        <p>{text.USE1}</p>
                        <p>{text.USE2}</p>
                        <p>{text.USE3}</p>
                        <p>{text.USE4}</p>
                        <p>{text.USE5}</p>
                        <h3>Children</h3>
                        <p>{text.CHILDREN}</p>
                        <h3>User Feedback</h3>
                        <p>{text.FEEDBACK}</p>
                        {this.renderDisclosureOfInfo()}
                        <h3>Use of Cookies</h3>
                        <p>{text.COOKIES1}</p>
                        <p>{text.COOKIES2}</p>
                        <p>{text.COOKIES3}</p>
                        <h3>Updating Your Information</h3>
                        <p>{text.UPDATE1}</p>
                        <p>{text.UPDATE2}</p>
                        <h3>Security</h3>
                        <p>{text.SECURITY1}</p>
                        <p>{text.SECURITY2}</p>
                        <h3>Changes to Privacy Policy</h3>
                        <p>{text.CHANGES}</p>
                        <h3>Contact Information</h3>
                        <p>{text.CONTACT1}</p>
                        <p>{text.CONTACT2}</p>
                        <p>{text.CONTACT3}</p>
                        <h3>Thank you for using Pollpals.com</h3>
                        <p>{text.THANKS1}</p>
                        <p>{text.THANKS2}</p>
                      </div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStyles = withStyles(profilePageStyle)(PpPage);

export default pageWithStyles;



// WEBPACK FOOTER //
// ./src/views/PP.js